// import React, { useEffect, useState } from "react";
// import {
//   getAllTags,
//   createTag,
//   updateTag,
//   deleteTag,
//   getTrendingTags,
// } from "../../../services/adminService";
// import { Button, Table, Form, Modal, Spinner, Alert } from "react-bootstrap";

// const TagManagement = () => {
//   const [tags, setTags] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [showModal, setShowModal] = useState(false);
//   const [editTag, setEditTag] = useState(null);
//   const [formData, setFormData] = useState({ name: "", isTrending: false });

//   // ✅ Fetch all tags
//   const fetchTags = async () => {
//     try {
//       setLoading(true);
//       const res = await getAllTags();
//       setTags(res.data || []);
//       setLoading(false);
//     } catch (err) {
//       setError("Failed to fetch tags");
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTags();
//   }, []);

//   // ✅ Handle form change
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData({
//       ...formData,
//       [name]: type === "checkbox" ? checked : value,
//     });
//   };

//   // ✅ Create / Update Tag
//   const handleSave = async () => {
//     try {
//       if (editTag) {
//         await updateTag(editTag._id, formData);
//       } else {
//         await createTag(formData);
//       }
//       setShowModal(false);
//       setFormData({ name: "", isTrending: false });
//       setEditTag(null);
//       fetchTags();
//     } catch (err) {
//       setError("Failed to save tag");
//     }
//   };

//   // ✅ Delete Tag
//   const handleDelete = async (id) => {
//     if (window.confirm("Are you sure you want to delete this tag?")) {
//       try {
//         await deleteTag(id);
//         fetchTags();
//       } catch (err) {
//         setError("Failed to delete tag");
//       }
//     }
//   };

//   // ✅ Open Edit Modal
//   const handleEdit = (tag) => {
//     setEditTag(tag);
//     setFormData({ name: tag.name, isTrending: tag.isTrending });
//     setShowModal(true);
//   };

//   return (
//     <div className="container mt-4">
//       <h2 className="mb-3">Tag Management</h2>

//       {error && <Alert variant="danger">{error}</Alert>}

//       <Button className="mb-3" onClick={() => setShowModal(true)}>
//         + Add New Tag
//       </Button>

//       {loading ? (
//         <Spinner animation="border" />
//       ) : (
//         <Table striped bordered hover>
//           <thead>
//             <tr>
//               <th>Name</th>
//               <th>Trending</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {tags.length > 0 ? (
//               tags.map((tag) => (
//                 <tr key={tag._id}>
//                   <td>{tag.name}</td>
//                   <td>{tag.isTrending ? "Yes" : "No"}</td>
//                   <td>
//                     <Button
//                       variant="warning"
//                       size="sm"
//                       onClick={() => handleEdit(tag)}
//                     >
//                       Edit
//                     </Button>{" "}
//                     <Button
//                       variant="danger"
//                       size="sm"
//                       onClick={() => handleDelete(tag._id)}
//                     >
//                       Delete
//                     </Button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="3" className="text-center">
//                   No tags found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       {/* ✅ Add/Edit Modal */}
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>{editTag ? "Edit Tag" : "Add Tag"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="tagName" className="mb-3">
//               <Form.Label>Tag Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="Enter tag name"
//               />
//             </Form.Group>

//             <Form.Group controlId="isTrending" className="mb-3">
//               <Form.Check
//                 type="checkbox"
//                 label="Trending"
//                 name="isTrending"
//                 checked={formData.isTrending}
//                 onChange={handleChange}
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleSave}>
//             {editTag ? "Update" : "Save"}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default TagManagement;


import React, { useEffect, useState } from "react";
import {
  getAllTags,
  createTag,
  updateTag,
  deleteTag,
} from "../../../services/adminService";
import {
  Button,
  Table,
  Form,
  Modal,
  Spinner,
  Alert,
  Badge,
} from "react-bootstrap";

const TagManagement = () => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editTag, setEditTag] = useState(null);
  const [formData, setFormData] = useState({ name: "", isTrending: false });

  // ✅ Fetch all tags
  const fetchTags = async () => {
    try {
      setLoading(true);
      const res = await getAllTags();
      setTags(res.data || []);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch tags");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  // ✅ Handle form change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ✅ Create / Update Tag
  const handleSave = async () => {
    try {
      if (editTag) {
        await updateTag(editTag._id, formData);
      } else {
        await createTag(formData);
      }
      setShowModal(false);
      setFormData({ name: "", isTrending: false });
      setEditTag(null);
      fetchTags();
    } catch (err) {
      setError("Failed to save tag");
    }
  };

  // ✅ Delete Tag
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this tag?")) {
      try {
        await deleteTag(id);
        setTags((prev) => prev.filter((tag) => tag._id !== id));
      } catch (err) {
        setError("Failed to delete tag");
      }
    }
  };

  // ✅ Open Edit Modal
  const handleEdit = (tag) => {
    setEditTag(tag);
    setFormData({ name: tag.name, isTrending: tag.isTrending });
    setShowModal(true);
  };

  // ✅ Toggle Trending from Table (without full refresh)
  const handleToggleTrending = async (tag) => {
    try {
      const updatedTag = { ...tag, isTrending: !tag.isTrending };

      await updateTag(tag._id, { isTrending: updatedTag.isTrending });

      setTags((prevTags) =>
        prevTags.map((t) =>
          t._id === tag._id ? { ...t, isTrending: updatedTag.isTrending } : t
        )
      );
    } catch (err) {
      setError("Failed to update trending status");
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-3 text-center fw-bold">🎯 Tag Management</h2>

      {error && <Alert variant="danger">{error}</Alert>}

      <div className="d-flex justify-content-end mb-3">
        <Button variant="primary" onClick={() => setShowModal(true)}>
          + Add New Tag
        </Button>
      </div>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <Table
          striped
          bordered
          hover
          responsive
          className="align-middle text-center shadow-sm"
        >
          <thead className="table-dark">
            <tr>
              <th style={{ width: "60px" }}>#</th>
              <th>Name</th>
              <th>Trending</th>
              <th style={{ width: "220px" }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tags.length > 0 ? (
              tags.map((tag, index) => (
                <tr key={tag._id}>
                  <td>{index + 1}</td>
                  <td className="fw-semibold">{tag.name}</td>
                  <td>
                    <Form.Check
                      type="switch"
                      id={`trending-${tag._id}`}
                      checked={tag.isTrending}
                      onChange={() => handleToggleTrending(tag)}
                      label={
                        tag.isTrending ? (
                          <Badge bg="success">Trending</Badge>
                        ) : (
                          <Badge bg="danger">Not Trending</Badge>
                        )
                      }
                    />
                  </td>
                  <td>
                    <Button
                      variant="warning"
                      size="sm"
                      className="me-2"
                      onClick={() => handleEdit(tag)}
                    >
                      ✏️ Edit
                    </Button>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDelete(tag._id)}
                    >
                      🗑 Delete
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-muted">
                  No tags found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}

      {/* ✅ Add/Edit Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editTag ? "Edit Tag" : "Add Tag"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="tagName" className="mb-3">
              <Form.Label>Tag Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter tag name"
              />
            </Form.Group>

            <Form.Group controlId="isTrending" className="mb-3">
              <Form.Check
                type="checkbox"
                label="Trending"
                name="isTrending"
                checked={formData.isTrending}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {editTag ? "Update" : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TagManagement;
